import {
  LOAD_ALL_SELLING_PRICES,
  LOAD_SINGLE_SELLING_PRICE,
} from "./SellingPricesList.saga";

export const loadAllSellingPrices = (payload) => ({
  type: LOAD_ALL_SELLING_PRICES.LOADING,
  payload,
});

export const loadSingleSellingPrice = (payload) => ({
  type: LOAD_SINGLE_SELLING_PRICE.LOADING,
  payload,
});
